import React from 'react';

import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import cs from 'classnames';

/**
 * @type {import('react').FC<import('./lib/types').DragDropListProps>}
 */

const DragAndDropList = ({
  items,
  onDragEnd,
  renderItem,
  droppableId = 'droppable',
  direction = 'vertical',
  className = '',
  parentClassName = ''
}) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [moved] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, moved);
    onDragEnd(newItems);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId={droppableId} direction={direction}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={parentClassName}>
            {items.map((item, index) => (
              <Draggable
                key={item.id || item.key || index}
                draggableId={item.id?.toString() || index.toString()}
                index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={cs('flex items-center justify-between gap-2 py-1', className)}>
                    {renderItem(item, index)}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragAndDropList;
